import axios from 'axios';
import { downloadFile } from '../utils/files';
import { variables } from '../utils/variables';
import { principal_raportsAPI } from './routes';

const getAll = async (page: number = 0) =>
  await axios.get(
    `${principal_raportsAPI.GET_ALL}?PageNumber=${page}&PageSize=${variables.paginationRatio}`
  );

const getRaport = async (id: number) =>
  await axios.get(principal_raportsAPI.BY_ID(id));

const downloadRaport = (id: number, name: string) => {
  axios
    .get(principal_raportsAPI.DOWNLOAD(id), { responseType: 'blob' })
    .then(({ data }) => {
      downloadFile(data, name);
    });
};

const addRaport = async (
  raport: File,
  raportName: string,
  doc?: File,
  docName?: string
) => {
  const data = new FormData();
  data.append('file', raport);
  data.append('name', raportName);

  if (doc && docName) {
    data.append('AdditionalDocumentName', docName);
    data.append('AdditionalDocumentFile', doc);
  }

  return await axios.post(principal_raportsAPI.ADD, data);
};

const importArchive = async (document: File) => {
  const data = new FormData();

  data.append('File', document);

  return await axios.post(principal_raportsAPI.ARCHIVE, data);
};

const addAdditionalDocument = async (
  doc: File,
  docName: string,
  ccrRaportId: number
) => {
  const data = new FormData();

  data.append('CcrReportId', ccrRaportId.toString());
  data.append('Name', docName);
  data.append('File', doc);

  return await axios.post(principal_raportsAPI.ADD_ADOCUMENT, data);
};

const deleteAdditionalDocument = async (id: number) =>
  await axios.delete(principal_raportsAPI.DELETE_DOCUMENT(id));

const updateRaport = async (
  decision: File,
  decisionName: string,
  ccrRaportId: number
) => {
  const data = new FormData();

  data.append('Id', ccrRaportId.toString());
  data.append('Name', decisionName);
  data.append('File', decision!);

  return await axios.put(principal_raportsAPI.MODIFY, data);
};
const deleteCcrReport = async (id: number) =>
  await axios.delete(principal_raportsAPI.DELETE(id));

/* followup raports */

const addFollowupRaport = async (
  id: number,
  raport: File,
  raportName: string
) => {
  const data = new FormData();
  data.append('file', raport);
  data.append('name', raportName);
  data.append('CcrReportId', id.toString());

  return await axios.post(principal_raportsAPI.FU_ADD, data);
};

const downloadFollowupRaport = (id: number, name: string) => {
  axios
    .get(principal_raportsAPI.FU_DOWNLOAD(id), { responseType: 'blob' })
    .then(({ data }) => {
      downloadFile(data, name);
    });
};

const deleteFollowUpReport = async (id: number) =>
  await axios.delete(principal_raportsAPI.FU_DELETE(id));

const downloadAditionalDocument = (id: number, name: string) => {
  axios
    .get(principal_raportsAPI.DOWNLOAD_ADOCUMENT(id), { responseType: 'blob' })
    .then(({ data }) => {
      downloadFile(data, name);
    });
};

const downloadDecisionRaport = (id: number, name: string) => {
  axios
    .get(principal_raportsAPI.DOWNLOAD_DECISION(id), { responseType: 'blob' })
    .then(({ data }) => {
      downloadFile(data, name);
    });
};

/* subordered institutions */
const getRaportsForInstitution = async (id: number) =>
  await axios.get(principal_raportsAPI.SUBORDERED_INSTITUTIONS(id));

const getAvailableUsers = async (id: number) =>
  await axios.get(principal_raportsAPI.CCR_REPORT_USERS(id));

const getCcrReportUsers = async (id: number) =>
  await axios.get(principal_raportsAPI.CCR_REPORT_USERS(id));

const addCcrReportUser = async (CcrReportId: number, userId: number) => {
  return await axios.post(
    principal_raportsAPI.CCR_REPORT_USER(CcrReportId, userId)
  );
};
const removeCcrReportUser = async (CcrReportId: number, userId: number) => {
  return await axios.delete(
    principal_raportsAPI.CCR_REPORT_USER(CcrReportId, userId)
  );
};

export {
  getAll,
  getRaport,
  downloadRaport,
  addRaport,
  addAdditionalDocument,
  downloadFollowupRaport,
  addFollowupRaport,
  downloadDecisionRaport,
  updateRaport,
  getRaportsForInstitution,
  downloadAditionalDocument,
  deleteAdditionalDocument,
  deleteFollowUpReport,
  deleteCcrReport,
  importArchive,
  getAvailableUsers,
  getCcrReportUsers,
  addCcrReportUser,
  removeCcrReportUser
};
